import { Box, Typography, styled } from '@mui/material'

const CustomFragment = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '473px',
  '& .ant-empty-img-1': {
    fill: theme.palette.mode === 'light' ? '#aeb8c2' : '#262626',
  },
  '& .ant-empty-img-2': {
    fill: theme.palette.mode === 'light' ? '#f5f5f7' : '#595959',
  },
  '& .ant-empty-img-3': {
    fill: theme.palette.mode === 'light' ? '#dce0e6' : '#434343',
  },
  '& .ant-empty-img-4': {
    fill: theme.palette.mode === 'light' ? '#fff' : '#1c1c1c',
  },
  '& .ant-empty-img-5': {
    fillOpacity: theme.palette.mode === 'light' ? '0.8' : '0.08',
    fill: theme.palette.mode === 'light' ? '#f5f5f5' : '#fff',
  },
}))

export function CustomNoRowsDataGrid() {
  return (
    <CustomFragment>
      <svg width="164" height="178" viewBox="0 0 164 178" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M20.5 48.3225H144.5V127.323H20.5V48.3225Z" fill="#ECEEF0" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.5 48.3225V168.323H0.5V95.7595L20.5 48.3225ZM144.5 48.3225V167.323H163.5V95.7595L144.5 48.3225Z"
          fill="#DADEE2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 95.8225V169.323C1 170.516 1.47411 171.661 2.31802 172.504C3.16193 173.348 4.30653 173.823 5.5 173.823H158.5C159.693 173.823 160.838 173.348 161.682 172.504C162.526 171.661 163 170.516 163 169.323V95.8225H1Z"
          fill="white"
          stroke="#DADEE2"
        />
        <g filter="url(#filter0_d_918_4203)">
          <rect x="59" y="110" width="46.1103" height="49.581" rx="23.0551" fill="white" />
          <rect x="59.5" y="110.5" width="45.1103" height="48.581" rx="22.5551" stroke="black" strokeOpacity="0.08" />
          <path
            d="M73.8921 147.104L72.2588 145.442L75.7005 142H73.0755V139.667H79.6671V146.258H77.3338V143.663L73.8921 147.104ZM82.0005 146.667V137.333H72.6671V125.667C72.6671 125.025 72.8956 124.476 73.3525 124.019C73.8095 123.562 74.3588 123.333 75.0005 123.333H84.3338L91.3338 130.333V144.333C91.3338 144.975 91.1053 145.524 90.6484 145.981C90.1914 146.438 89.6421 146.667 89.0005 146.667H82.0005ZM83.1671 131.5H89.0005L83.1671 125.667V131.5Z"
            fill="#9E9E9E"
          />
        </g>
        <path
          d="M111.932 138.312C105.814 136.818 99.714 140.831 98.2997 147.274C97.8055 149.506 97.9248 151.827 98.6405 153.969H98.6406L99.3746 155.824L100.344 157.28C104.161 162.553 111.284 163.56 116.277 159.529C121.269 155.498 122.224 147.976 118.407 142.703C116.805 140.49 114.505 138.942 111.932 138.312Z"
          fill="#6DD400"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M109.143 156.823C111.104 156.777 112.73 156.072 114.023 154.706C115.316 153.341 115.984 151.622 116.027 149.551C115.984 147.48 115.316 145.762 114.023 144.397C112.73 143.031 111.104 142.326 109.143 142.28C107.182 142.326 105.555 143.031 104.262 144.397C102.969 145.762 102.301 147.48 102.258 149.551C102.279 151.008 102.635 152.305 103.324 153.443L102.258 156.823L105.458 155.696C106.535 156.424 107.763 156.8 109.143 156.823ZM109.141 155.39C107.934 155.367 106.878 155.014 105.973 154.331L103.969 155.014L104.616 152.898C103.969 151.942 103.635 150.827 103.614 149.552C103.657 147.891 104.196 146.514 105.23 145.422C106.264 144.329 107.568 143.76 109.141 143.715C110.714 143.76 112.018 144.329 113.052 145.422C114.086 146.514 114.625 147.891 114.668 149.552C114.625 151.213 114.086 152.59 113.052 153.683C112.018 154.775 110.714 155.344 109.141 155.39ZM111.406 152.863C111.298 152.908 111.136 152.925 110.921 152.914C110.705 152.903 110.188 152.715 109.369 152.351C108.507 151.896 107.834 151.338 107.349 150.678C106.864 150.018 106.595 149.637 106.541 149.534C106.487 149.432 106.369 149.199 106.185 148.835C106.002 148.471 105.916 148.061 105.927 147.606C105.938 147.151 106.018 146.809 106.169 146.582C106.32 146.354 106.449 146.195 106.557 146.104C106.751 145.922 106.913 145.853 107.042 145.899H107.365C107.408 145.899 107.462 145.91 107.527 145.933C107.591 145.956 107.656 146.058 107.721 146.24L108.206 147.606C108.27 147.697 108.27 147.799 108.206 147.913L108.044 148.22L107.753 148.527C107.71 148.573 107.678 148.624 107.656 148.681C107.635 148.738 107.645 148.812 107.688 148.903C107.732 148.994 107.834 149.165 107.996 149.415C108.157 149.665 108.356 149.927 108.593 150.2C108.917 150.496 109.197 150.712 109.434 150.849L109.951 151.122C110.102 151.236 110.22 151.224 110.307 151.088L110.856 150.405C110.921 150.337 110.985 150.303 111.05 150.303C111.115 150.303 111.19 150.314 111.276 150.337L112.408 150.985C112.58 151.054 112.682 151.116 112.715 151.173C112.747 151.23 112.758 151.338 112.747 151.497C112.736 151.657 112.688 151.844 112.602 152.061C112.515 152.277 112.343 152.465 112.084 152.624C111.826 152.783 111.6 152.863 111.406 152.863Z"
          fill="white"
        />
        <path
          d="M131.99 21.4276C131.99 10.1442 122.8 1 111.46 1C103.72 1 96.9798 5.26861 93.4798 11.5571C90.5098 7.95515 86.0098 5.65667 80.9698 5.65667C72.0398 5.65667 64.7998 12.8606 64.7998 21.746C64.7998 27.9151 68.2998 33.2783 73.4298 35.9748L72.8198 35.8354C61.5598 57.3775 68.9198 83.6558 68.9198 83.6558C71.7498 70.5217 77.0798 61.5367 82.7398 55.4173C82.7398 55.4173 90.7498 46.0045 98.3998 44.8403C98.3998 44.8403 94.7298 47.308 91.2998 52.8601C92.8498 60.1337 99.3398 65.5963 107.11 65.5963C116.04 65.5963 123.28 58.3924 123.28 49.5069C123.28 45.9348 122.09 42.6413 120.11 39.9648C127.13 36.721 132 29.6465 132 21.4376L131.99 21.4276Z"
          fill="#ECEEF1"
          stroke="white"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M131.7 21.4276C131.7 10.1442 122.51 1 111.17 1C103.43 1 96.6898 5.26861 93.1898 11.5571C90.2198 7.95515 85.7198 5.65667 80.6798 5.65667C71.7498 5.65667 64.5098 12.8606 64.5098 21.746C64.5098 27.9151 68.0098 33.2783 73.1398 35.9748L72.5298 35.8354C61.2698 57.3775 68.6298 83.6558 68.6298 83.6558C71.4598 70.5217 76.7898 61.5367 82.4498 55.4173C82.4498 55.4173 90.4598 46.0045 98.1098 44.8403C98.1098 44.8403 94.4398 47.308 91.0098 52.8601C92.5598 60.1337 99.0498 65.5963 106.82 65.5963C115.75 65.5963 122.99 58.3924 122.99 49.5069C122.99 45.9348 121.8 42.6413 119.82 39.9648C126.84 36.721 131.71 29.6465 131.71 21.4376L131.7 21.4276Z"
          fill="#ECEEF1"
          stroke="white"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M35.5 34.3975L40.18 40.6163L47.98 40.3078L43.48 46.6461L46.19 53.9395L38.73 51.6411L32.61 56.4569L32.49 48.6859L26 44.3775L33.39 41.87L35.5 34.3975Z"
          fill="#B6BDC4"
        />
        <path
          d="M89.7199 73.5513L92.1999 76.8547L96.3499 76.6955L93.9599 80.0686L95.3999 83.9392L91.4399 82.7154L88.1799 85.2725L88.1199 81.1532L84.6699 78.8547L88.5999 77.5214L89.7199 73.5513Z"
          fill="#DADEE2"
        />
        <path
          d="M50.1958 11.788L49.5251 15.864L52.5104 18.7512L48.4211 19.3579L46.6215 23.075L44.7666 19.3684L40.665 18.7825L43.5987 15.8901L42.8727 11.8086L46.5538 13.7249L50.1958 11.788Z"
          fill="#DADEE2"
        />
        <path
          d="M156.35 25.686L157.01 29.7556L160.76 31.5168L157.08 33.4073L156.55 37.5068L153.61 34.6014L149.53 35.3675L151.4 31.686L149.4 28.0641L153.5 28.691L156.35 25.686Z"
          fill="#B6BDC4"
        />
        <defs>
          <filter
            id="filter0_d_918_4203"
            x="44"
            y="98"
            width="76.1104"
            height="79.581"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect1_dropShadow_918_4203" />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="8" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_918_4203" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_918_4203" result="shape" />
          </filter>
        </defs>
      </svg>

      <Box sx={{ mt: 2, maxWidth: 764 }}>
        <Typography variant="h6" align="center" mb="13px" sx={{ color: '#666', fontSize: '16px' }}>
          Não há registros de exportação
        </Typography>
        <Typography variant="subtitle1" align="center" sx={{ color: '#666', fontSize: '14px', lineHeight: '143%' }}>
          Você não realizou exportações de dados relacionados ao WhatsApp no período selecionado.
        </Typography>
      </Box>
    </CustomFragment>
  )
}
